import { UserInvitePersonaType, UserSignupPersonaType } from "./persona-types";

const RESOURCE_STYLING = {
  blue: {
    icon: "Clipboard",
    color: "blue",
    tag: "Onepager",
  },
  green: {
    icon: "Signpost",
    color: "green",
    tag: "Guide",
  },
  orange: {
    icon: "Book",
    color: "orange",
    tag: "Library",
  },
};

export const RECOMMENDED_RESOURCES = [
  {
    id: "wisnio_for_candidates",
    title_key: "resources.wisnio_for_candidates_title",
    url: "https://drive.google.com/file/d/1R3qXgdZCglePh-uykUBc-GNgAIGar5rG/view?usp=sharing",
    order: 1,
    ...RESOURCE_STYLING.blue,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.CANDIDATE,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.HIRING,
    ],
  },
  {
    id: "example_wisgpt_prompts_for_candidate",
    title_key: "resources.example_wisgpt_prompts_for_candidate_title",
    url: "https://support.assessio.ai/en/articles/9398850-candidate-profile-analysis#h_ef318de14e",
    order: 2,
    ...RESOURCE_STYLING.orange,
    personas: [
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.HIRING,
    ],
  },
  {
    id: "example_wisgpt_prompts_for_team",
    title_key: "resources.example_wisgpt_prompts_for_team_title",
    url: "https://support.assessio.ai/en/articles/4768965-team-profile-analysis-learn-how-to-read-and-interpret-team-profile-graphs#h_e841795a68a",
    order: 3,
    ...RESOURCE_STYLING.orange,
    personas: [
      UserInvitePersonaType.TEAM_MEMBER,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  {
    id: "setup_projects_guide",
    title_key: "resources.setup_projects_guide_title",
    url: "https://support.assessio.ai/en/articles/4769000-how-to-set-up-a-new-project-in-assessioai",
    order: 4,
    ...RESOURCE_STYLING.green,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
    ],
  },
  {
    id: "candidate_profile_interpretation_guide",
    title_key: "resources.candidate_profile_interpretation_guide_title",
    url: "https://drive.google.com/file/d/13lg9Iyt_uc4xqGEw3eaqvTOf8FCUN-Xw/view?usp=sharing",
    order: 5,
    ...RESOURCE_STYLING.green,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.HIRING,
    ],
  },
  {
    id: "team_development_guide",
    title_key: "resources.team_development_guide_title",
    url: "https://drive.google.com/file/d/1sI27A92DMsScEe5N-6TIovIeyurz97L4/view?usp=share_link",
    order: 6,
    ...RESOURCE_STYLING.green,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.TEAM_MEMBER,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.PERSONAL,
      UserSignupPersonaType.HIRING,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  {
    id: "wisnio_science",
    title_key: "resources.wisnio_science_title",
    url: "https://drive.google.com/file/d/1eDcEG54V7eYD5aA7CkL4mUDFaSoRttBC/view?usp=share_link",
    order: 7,
    ...RESOURCE_STYLING.blue,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.CANDIDATE,
      UserInvitePersonaType.ORG_MEMBER,
      UserInvitePersonaType.TEAM_MEMBER,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.PERSONAL,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  {
    id: "how_to_pitch_wisnio",
    title_key: "resources.how_to_pitch_wisnio_title",
    url: "https://drive.google.com/file/d/1rWaxeWXN0iul_DtPQL28aqDyZUO2G9Ql/view",
    order: 8,
    ...RESOURCE_STYLING.blue,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
    ],
  },
];
